import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UnSavedChangesGuard } from './guards/un-saved-changes.guard';
import { CvDetailComponent } from './modules/cv-detail/cv-detail.component';
import { CvResolver } from './modules/cv-detail/cv.resolver';
import { CvByIdResolver } from './modules/cv-detail/cvById.resolver';
import { BranchOfferResolver } from './modules/skill-data/branch-offer.resolver';
import { CvListComponent } from './modules/cv-list/pages/cv-list.component';
import { SearchOverviewComponent } from './modules/search-overview/search-overview.component';
import { CvsByUserIdAndCvTypeResolver } from './modules/cv-list/resolvers/CvsByUserIdAndCvType.resolver';
import { LoginComponent } from './modules/login/login.component';
import { CanActivateSearchGuard } from './guards/can-search.guard';

const routes: Routes = [
  {
    path: 'cv-detail/en', component: CvDetailComponent,
    data: {lang: "en"}, resolve: { cv: CvResolver, branchOffers: BranchOfferResolver },
    canDeactivate: [UnSavedChangesGuard]
  },
  {
    path: 'cv-detail/de', component: CvDetailComponent,
    data: {lang: "de"}, resolve: { cv: CvResolver, branchOffers: BranchOfferResolver },
    canDeactivate: [UnSavedChangesGuard]
  },
  {
    path: 'cv-detail/en/:cvId', component: CvDetailComponent,
    data: {lang: "en"}, resolve: { cv: CvByIdResolver, branchOffers: BranchOfferResolver },
    canDeactivate: [UnSavedChangesGuard]
  },
  {
    path: 'cv-detail/de/:cvId', component: CvDetailComponent,
    data: {lang: "de"}, resolve: { cv: CvByIdResolver, branchOffers: BranchOfferResolver },
    canDeactivate: [UnSavedChangesGuard]
  },
  {
    path: 'consultant-cv/de/:cvId', component: CvDetailComponent,
    data: {lang: "de"}, resolve: { cv: CvByIdResolver, branchOffers: BranchOfferResolver },
    canDeactivate: [UnSavedChangesGuard]
  },
  {
    path: 'consultant-cv/en/:cvId', component: CvDetailComponent,
    data: {lang: "en"}, resolve: { cv: CvByIdResolver, branchOffers: BranchOfferResolver },
    canDeactivate: [UnSavedChangesGuard]
  },
  {
    path: 'cv-list/:userId', component: CvListComponent, resolve: { cvList: CvsByUserIdAndCvTypeResolver}
  },
  {
    path: 'cv-list', component: CvListComponent
  },
  {
    path: 'search', component: SearchOverviewComponent,
    canActivate: [CanActivateSearchGuard]
  },
  {
    path: 'login', component: LoginComponent
  },
  {path: '', redirectTo: 'cv-detail/de', pathMatch: 'full', canDeactivate: [UnSavedChangesGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
